// extracted by mini-css-extract-plugin
export default {"hero-text":"Hero_hero-text__xobGc"};